export default "__VITE_ASSET__CnabPv7E__"